/*
  Keeps free gifts in sync with cart quantities.
  For each distinct product in the cart, fetches that product's page once
  (cached) to read its quantity-break block's configured gift
  (data-auto-add-product / data-auto-add-variant) and required quantity
  (data-qty) — no hardcoded product/gift pairs. Adds the gift when a
  product's cart quantity meets its own threshold, removes it when it
  no longer does. Shows a loading overlay over the cart items during sync.
*/
(function () {
  var isProcessing = false;
  var CART_MUTATION_PATHS = ['/cart/change', '/cart/update', '/cart/add', '/cart/clear'];
  var pairingCache = {}; // productId -> {requiredQty, giftVariantId, giftProductId} | null

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    var path = url.toString().split('?')[0];
    return CART_MUTATION_PATHS.some(function (endpoint) {
      return path.indexOf(endpoint) !== -1;
    });
  }

  function showOverlay() {
    var overlay = document.getElementById('CartDrawer-GiftSyncOverlay');
    if (overlay) overlay.classList.remove('hidden');
  }

  function hideOverlay() {
    var overlay = document.getElementById('CartDrawer-GiftSyncOverlay');
    if (overlay) overlay.classList.add('hidden');
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var shouldCheck = isCartMutationUrl(url) && !isProcessing;

     return originalFetch.apply(this, arguments).then(function (response) {
      // Never schedule a recheck while we're mid-sync — syncCart's own
      // add/change/section fetches would otherwise retrigger us in a loop.
      if (shouldCheck && !isProcessing) {
        setTimeout(function () {
          if (!isProcessing) checkGiftEligibility();
        }, 250);
      }
      return response;
    });
  };

  function fetchCartJson() {
    return fetch(rootUrl() + 'cart.js').then(function (res) { return res.json(); });
  }

  function fetchProductPairing(productId, productUrl) {
    if (Object.prototype.hasOwnProperty.call(pairingCache, productId)) {
      return Promise.resolve(pairingCache[productId]);
    }
    return fetch(productUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var blocks = Array.from(doc.querySelectorAll('lumin-product-qty-break'));
        var pairing = null;

        for (var i = 0; i < blocks.length; i++) {
          var giftVariantId = blocks[i].getAttribute('data-auto-add-variant');
          var giftProductId = blocks[i].getAttribute('data-auto-add-product');
          var requiredQty = parseInt(blocks[i].getAttribute('data-qty'), 10) || 0;

          if (giftVariantId && giftProductId && requiredQty > 0) {
            pairing = { requiredQty: requiredQty, giftVariantId: giftVariantId, giftProductId: giftProductId };
            break; // first configured tier wins
          }
        }

        pairingCache[productId] = pairing;
        return pairing;
      })
      .catch(function (error) {
        console.error('Error fetching gift pairing for product ' + productId, error);
        pairingCache[productId] = null;
        return null;
      });
  }

     function checkGiftEligibility() {
    if (isProcessing) return;

       fetchCartJson().then(function (cart) {
      // Sum how many units of each variant are actually in the cart right now.
      var qtyByVariantId = {};
      cart.items.forEach(function (item) {
        // Don't count gift lines themselves toward the pack quantity.
        var isGift = item.properties && item.properties._gift_pack_variants;
        if (isGift) return;
        qtyByVariantId[item.variant_id] =
          (qtyByVariantId[item.variant_id] || 0) + item.quantity;
      });

      var toRemove = [];

      cart.items.forEach(function (item) {
        var props = item.properties || {};
        var packVariants = props._gift_pack_variants;
        if (!packVariants) return; // not a tagged gift

        // Count how many units of each distinct variant the pack needs.
        // (packVariants lists one id per unit, so a same-variant 3-pack
        // looks like "111,111,111" — three separate requirements on 111,
        // not one requirement of 3x the summed cart total.)
        var packCounts = {};
        packVariants.split(',').forEach(function (id) {
          id = id.trim();
          packCounts[id] = (packCounts[id] || 0) + 1;
        });

        // Gift survives only if the cart still holds at least the required
        // count of every distinct variant in the pack.
        var stillEligible = Object.keys(packCounts).every(function (id) {
          return (qtyByVariantId[id] || 0) >= packCounts[id];
        });

        if (!stillEligible) {
          toRemove.push(item.key);
        }
      });

      if (toRemove.length === 0) return;
      syncCart([], toRemove);
    }).catch(function (error) {
      console.error('Error checking gift eligibility:', error);
    });
  }
  function applySections(sections) {
    var cartDrawer = document.querySelector('cart-drawer');
    var newInner = new DOMParser()
      .parseFromString(sections['cart-drawer'], 'text/html')
      .querySelector('#CartDrawer');
    var currentInner = cartDrawer && cartDrawer.querySelector('#CartDrawer');
    if (newInner && currentInner) {
      currentInner.innerHTML = newInner.innerHTML;
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var newBubble = new DOMParser()
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (newBubble) bubble.innerHTML = newBubble.innerHTML;
    }

    document.dispatchEvent(new CustomEvent('cart-update'));
  }

  function syncCart(itemsToAdd, variantIdsToRemove) {
    isProcessing = true;
    showOverlay();

    var removals = variantIdsToRemove.map(function (lineKey) {
      return fetch(rootUrl() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      });
    });

    Promise.all(removals)
      .then(function () {
        if (itemsToAdd.length === 0) return null;
        return fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd }),
        });
      })
      .then(function () {
        return fetch(rootUrl() + '?sections=cart-drawer,cart-icon-bubble').then(function (res) {
          return res.json();
        });
      })
      .then(applySections)
      .catch(function (error) {
        console.error('Error syncing free gifts:', error);
      })
      .finally(function () {
        isProcessing = false;
        hideOverlay();
      });
  }

  document.addEventListener('DOMContentLoaded', checkGiftEligibility);

  // Also recheck whenever anything in the theme announces the cart changed.
  // Covers quantity updates that don't go through the intercepted window.fetch
  // above, or that resolve before/after that check's timing window.
  document.addEventListener('cart-update', function () {
    if (!isProcessing) checkGiftEligibility();
  });
})();